import { client } from '../../utils'
import { successFactors as endpoints } from '../../api_urls'

export const updateOrganizations = organizations => ({
  type: 'UPDATE_ORGANIZATIONS',
  organizations: organizations,
})

export const updateSelectedOrg = selectedOrgId => ({
  type: 'UPDATE_SELECTED_ORG',
  selectedOrgId: selectedOrgId,
})

export const showDeleteOrgModal = orgDeleteId => ({
  type: 'SHOW_DELETE_ORG',
  orgDeleteId: orgDeleteId,
})

export const hideDeleteOrgModal = () => ({
  type: 'HIDE_DELETE_ORG',
  orgDeleteId: null,
})

export const showDeleteCourseModal = courseDeleteId => ({
  type: 'SHOW_DELETE_COURSE',
  courseDeleteId: courseDeleteId,
})

export const hideDeleteCourseModal = () => ({
  type: 'HIDE_DELETE_COURSE',
  courseDeleteId: null,
})

export const updateConnectedCourses = connectedCourseList => ({
  type: 'UPDATE_CONNECTED_COURSES',
  connectedCourses: connectedCourseList,
})

export const connectEditCourse = (selectedOrgId, courseData) => {
  return async dispatch => {
    let formData = new FormData()
    formData.append('orgId', selectedOrgId)
    formData.append('courseNum', courseData.courseNum)
    formData.append('description', courseData.descr)
    formData.append('thumbnailUri', courseData.thumbnailUri)
    try {
      let response = await client.post(endpoints.connectEditCourse(), formData)
      dispatch(updateConnectedCourses(response.data.connectedCourses))
      dispatch(updateOrganizations(response.data.organizations))
      return response
    } catch (err) {
      console.log(err)
    }
  }
}

export const getConnectedCourses = selectedOrgId => {
  return async dispatch => {
    try {
      let response = await client.get(
        endpoints.getConnectedCourses({ orgId: selectedOrgId })
      )
      dispatch(updateConnectedCourses(response.data.connectedCourses))
    } catch (err) {
      console.log(err)
    }
  }
}

export const newOrganization = newOrg => {
  return async dispatch => {
    let url = endpoints.createOrg()
    let formData = new FormData()
    formData.append('name', newOrg.orgName)
    formData.append('main_contact', newOrg.contact)
    formData.append('provider_id', newOrg.providerId)
    formData.append('oauth_token', newOrg.oauthToken)
    formData.append('base_api_url', newOrg.baseUrl)
    try {
      let response = await client.post(url, formData)
      dispatch(updateOrganizations(response.data.organizations))
      return response
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
    }
  }
}

export const editOrganization = orgData => {
  return async dispatch => {
    let url = endpoints.updateOrg({ orgId: orgData.id })
    let formData = new FormData()
    formData.append('name', orgData.orgName)
    formData.append('main_contact', orgData.contact)
    formData.append('provider_id', orgData.providerId)
    formData.append('sfUserId', orgData.sfUserId)
    formData.append('clientId', orgData.clientId)
    formData.append('clientSecret', orgData.clientSecret)
    formData.append('base_api_url', orgData.baseUrl)
    try {
      let response = await client.post(url, formData)
      dispatch(updateOrganizations(response.data.organizations))
      return response
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
    }
  }
}

export const deleteOrganization = orgData => {
  return async dispatch => {
    let url = endpoints.deleteOrg({ orgId: orgData.id })
    try {
      let response = await client.delete(url)
      dispatch(updateOrganizations(response.data.organizations))
      return response
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
    }
  }
}

export const publishOrganization = orgData => {
  return async dispatch => {
    let url = endpoints.publishOrg({ orgId: orgData.id })
    try {
      let response = await client.get(url)
      dispatch(updateOrganizations(response.data.organizations))
      return response
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
    }
  }
}

export const selectOrganization = selectedOrgId => {
  return dispatch => {
    dispatch(updateSelectedOrg(selectedOrgId))
  }
}

export const showDeleteModal = orgDeleteId => {
  return dispatch => {
    dispatch(showDeleteOrgModal(orgDeleteId))
  }
}

export const hideDeleteModal = () => {
  return dispatch => {
    dispatch(hideDeleteOrgModal())
  }
}

export const deleteCourse = courseData => {
  return async dispatch => {
    let url = endpoints.deleteCourse({ courseId: courseData.id })
    try {
      let response = await client.delete(url)
      dispatch(updateConnectedCourses(response.data.connectedCourses))
      dispatch(updateOrganizations(response.data.organizations))
      return response
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
    }
  }
}
export const showDeleteCourseModalMethod = courseDeleteId => {
  return dispatch => {
    dispatch(showDeleteCourseModal(courseDeleteId))
  }
}

export const hideDeleteCourseModalMethod = () => {
  return dispatch => {
    dispatch(hideDeleteCourseModal())
  }
}
